import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import useStore from "../store/useStore";

import "swiper/css";
import "swiper/css/navigation";

export default function ContactoAgenda() {
  const { contactoAgenda, getContactoAgenda } = useStore();

  useEffect(() => {
    getContactoAgenda();
  }, [getContactoAgenda]);

  if (!contactoAgenda?.length) return null;

  const baseUrl = process.env.REACT_APP_STRAPI_URL || "";

  const getMediaUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    return `${baseUrl}${url}`;
  };

  return (
    <section className="relative w-full pt-14 pb-8">
      <div className="container">
        <h3 className="text-sidom-light text-[34px] md:text-[56px] font-light text-center mb-8 md:mb-10">
          Agende una reunión con nuestro equipo:
        </h3>
      </div>

      <div className="relative w-[calc(100%-90px)] md:w-[calc(100%-120px)] mx-auto">
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            prevEl: ".agenda-swiper-prev",
            nextEl: ".agenda-swiper-next",
          }}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={contactoAgenda.length > 3}
          speed={700}
          spaceBetween={20}
          slidesPerView={1.05}
          breakpoints={{
            768: { slidesPerView: 1, spaceBetween: 20 },
            1024: { slidesPerView: 2, spaceBetween: 22 },
            1400: { slidesPerView: 3, spaceBetween: 24 },
          }}
          className="agenda-swiper"
        >
          {contactoAgenda.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="rounded-[8px] px-6 pt-5 pb-4 min-h-[190px] bg-transparent">
                <div className="flex items-start gap-6">
                  <div className="shrink-0">
                    <div className="w-[120px] h-[120px] md:w-[150px] md:h-[150px] rounded-full overflow-hidden bg-white shrink-0">
                      {item?.foto?.url ? (
                        <img
                          src={getMediaUrl(item.foto.url)}
                          alt={item.nombre || "Colaborador"}
                          className="w-full h-full object-cover"
                          draggable={false}
                        />
                      ) : null}
                    </div>
                  </div>

                  <div className="flex-1 min-w-0 pt-1">
                    <h3 className="text-white font-semibold text-[18px] md:text-[20px] leading-[1.1] break-words text-left">
                      {item.nombre}
                    </h3>

                    <p className="text-sidom-light text-[14px] md:text-[16px] leading-[1.2] mt-3 text-left">
                      {item.cargo}
                    </p>

                    {!!item?.paises?.length && (
                      <div className="flex flex-wrap gap-2 mt-4">
                        {item.paises.map((pais) => (
                          <img
                            key={pais.id}
                            src={getMediaUrl(pais.url)}
                            alt={pais.alternativeText || pais.name || "País"}
                            className="w-[34px] h-[34px] rounded-full object-cover"
                            draggable={false}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-5">
                  {item.link ? (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                      className="block w-full text-center bg-sidom-orange text-white font-semibold text-[14px] rounded-full py-2 hover:opacity-90 transition"
                    >
                      AGENDAR REUNIÓN
                    </a>
                  ) : (
                    <div className="block w-full text-center bg-sidom-orange text-white font-semibold text-[14px] rounded-full py-2">
                      AGENDAR REUNIÓN
                    </div>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <button
          type="button"
          className="agenda-swiper-prev absolute left-[-26px] md:left-[-36px] top-1/2 -translate-y-1/2 z-20 w-[76px] h-[76px] rounded-full bg-white flex items-center justify-center shadow-md"
          aria-label="Anterior"
        >
          <span className="text-[44px] leading-none text-sidom-blue">‹</span>
        </button>

        <button
          type="button"
          className="agenda-swiper-next absolute right-[-26px] md:right-[-36px] top-1/2 -translate-y-1/2 z-20 w-[76px] h-[76px] rounded-full bg-white flex items-center justify-center shadow-md"
          aria-label="Siguiente"
        >
          <span className="text-[44px] leading-none text-sidom-blue">›</span>
        </button>
      </div>
    </section>
  );
}